import { render, staticRenderFns } from "./ListItemSurvey.vue?vue&type=template&id=2a05ff7a&scoped=true&"
import script from "./ListItemSurvey.vue?vue&type=script&lang=js&"
export * from "./ListItemSurvey.vue?vue&type=script&lang=js&"
import style0 from "./ListItemSurvey.vue?vue&type=style&index=0&id=2a05ff7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a05ff7a",
  null
  
)

export default component.exports